import {
    SET_FILTER_DATA,
    TOGGLE_FILTER
} from '../types'

export const setFilter = (filterType, data) => {
    return (
        {
            type: SET_FILTER_DATA,
            payload: data,
            filterType
        }
    )
}

export const toggleFilter = (filterType) => {
    return (
        {
            type: TOGGLE_FILTER,
            filterType
        }
    )
}

